import { useCallback, useState } from "react"

const DEFAULT_NOTIFICATION_TIMEOUT = 3000

const generateId = () => self?.crypto?.randomUUID() || (((1+Math.random())*0x10000)|0).toString(16)

export function useNotificationManager(){
    const [notificationList,setNotificationList] = useState([])
    const clearNotification = useCallback((id)=> {
        if(id){
            setNotificationList(prevNotificationList => {
                const notificationIndex = prevNotificationList.findIndex(notification => notification.id === id)
                if(notificationIndex>=0){
                    prevNotificationList.splice(notificationIndex,1)
                    return [
                        ...prevNotificationList.slice(0,notificationIndex),
                        ...prevNotificationList.slice(notificationIndex+1)
                    ]
                } else {
                    return prevNotificationList
                }
            })
        } else {
            setNotificationList([])
        }
    },[])

    const sendNotification = useCallback((notification)=>{
    
        if(!notification){
            return null
        }

        let {title, message, timeout, icon, clearExisting=false } = notification

        if(!title){
            title = notification
        }

        if(clearExisting){
            clearNotification()
        }

        const id = generateId();
        setNotificationList(prevNotificationList => {
            return [...prevNotificationList,{
                id,
                icon,
                title,
                message
            }]
        })
        const time = isFinite(timeout) && timeout>0?timeout:DEFAULT_NOTIFICATION_TIMEOUT
        setTimeout(()=>clearNotification(id),time)
        return id
    },[clearNotification])

    return {notificationList, sendNotification, clearNotification}
}